import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
// Custom components
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { allBranchDetail, getFollowup, getNextFollowup, viewLead } from '../../../redux/actions/Files.action';
import userPhoto from '../../../assets/img/user.png'
import moment from 'moment';
import { IoSearchOutline } from 'react-icons/io5';
import { useMemo } from 'react';
import { FaCalendarPlus, FaEdit } from 'react-icons/fa';
import { MdCampaign, MdDescription, MdWhatsapp } from 'react-icons/md';
import { Button, Form, Modal } from 'react-bootstrap';
import FileUpdate from 'views/admin/lead/FileUpdate';
import { getMessage } from '../../../redux/actions/Setting.action';

import { FaRegClock, FaUser } from 'react-icons/fa';
import { MdDateRange, MdDelete, MdLocationOn, MdComment } from 'react-icons/md';
import { FaPhone, FaWpforms } from 'react-icons/fa6';
import { FiTarget } from 'react-icons/fi';

// Add responsive styles
const responsiveStyles = `
  /* Styles for all screen sizes */
  .mobile-only-button {
    display: none !important;
  }
  
  @media only screen and (max-width: 768px) {
    .mobile-only-button {
      display: inline-flex !important;
    }
  }
`;
export default function AllFollowUp() {

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const [updateId, setUpdateId] = useState('');
    const [updateModal, setUpdateModal] = useState(false);
    const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
    const [whatsappDropdownSelection, setWhatsappDropdownSelection] = useState('');
    const [whatsAppMessage, setWhatsAppMessage] = useState([]);
    const [otherMessage, setOtherMessage] = useState('');
    const [errors, setErrors] = useState({ dropdown: '', other: '' });
    const [selectedLeadName, setSelectedLeadName] = useState('');
    const [selectedMobileNumber, setSelectedMobileNumber] = useState('');

    const updateToggle = (id) => {
        setUpdateModal(!updateModal);
        dispatch(viewLead(id?._id))
        if (!updateModal) {
            setUpdateId(id);
        } else {
            setUpdateId('');
        }
    };
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
        startDate: '',
        endDate: '',
        status: ''
    });

    const dispatch = useDispatch();
    const getFollowups = useSelector((state) => state.files);
    console.log('getFollowups', getFollowups);

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        getFollowups?.getFollowup?.data?.totalPatients / postPerPage,
    );

    useEffect(() => {
        const queryParams = {
            page: mainPage,
            limit: rowsPerPage,
            search: searchTerm.trim()
        }
        dispatch(getFollowup(queryParams))
    }, [mainPage, rowsPerPage, searchTerm])

    useEffect(() => {
        dispatch(getMessage())
            .then((res) => {
                if (res?.status == 200) {
                    setWhatsAppMessage(res?.data?.data || []);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    const openWhatsappModal = (mobileNumber, firstName, lastName) => {
        setSelectedMobileNumber(mobileNumber);
        setSelectedLeadName(`${firstName} ${lastName}`);
        setIsWhatsappModalOpen(true);
    };

    const closeWhatsappModal = () => {
        setIsWhatsappModalOpen(false);
        setWhatsappDropdownSelection('');
        setOtherMessage('');
        setErrors({ dropdown: '', other: '' });
    };

    const handleSend = () => {
        let hasError = false;
        const newErrors = { dropdown: '', other: '' };

        if (!whatsappDropdownSelection) {
            newErrors.dropdown = 'Please select a message option.';
            hasError = true;
        }

        if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
            newErrors.other = 'Please enter your custom message.';
            hasError = true;
        }

        setErrors(newErrors);
        if (hasError) return;

        let formattedNumber = selectedMobileNumber;
        // if (!formattedNumber.startsWith('91')) {
        //     formattedNumber = `91${formattedNumber}`;
        // }

        let messageToSend = '';
        if (whatsappDropdownSelection === 'other') {
            messageToSend = otherMessage;
            setOtherMessage('');
        } else {
            const selectedMsgObj = whatsAppMessage.find((msg) => msg._id === whatsappDropdownSelection);
            messageToSend = selectedMsgObj?.description || '';
            setOtherMessage('');
        }

        const encodedMessage = encodeURIComponent(messageToSend);
        const whatsappURL = `https://api.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

        window.open(whatsappURL, '_blank');
        closeWhatsappModal();
    };
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
    
        hours = hours % 12;
        hours = hours || 12;
        const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
    
        return `${hours}:${minutesFormatted} ${ampm}`;
      };
    const handlePhoneClick = (phoneNumber) => {
        window.location.href = `tel:${phoneNumber}`;
      };
    return (
        <>
            <style>{responsiveStyles}</style>
            <div className="mt-[100px]">
                <div className="d-flex justify-between items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className='fw-bold'>All Followup</h3>
                    <div className='ms-auto border-r pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{getFollowups?.getFollowup?.data?.totalPatients || 0}</span></div>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        {/* <Thead>
                            <Tr>
                                <Th>Next Followup Date</Th>
                                <Th>Branch</Th>
                                <Th>Phone Number</Th>
                                <Th>First Name</Th> */}
                                {/* <Th>Middle Name</Th> */}
                                {/* <Th>Last Name</Th>
                                <Th>Lead Status</Th>
                                <Th>Lead From</Th>
                                <Th>Consult</Th>
                                <Th>Gender</Th>
                                <Th>Date of Birth</Th>
                                <Th>Country</Th>
                                <Th>State</Th>
                                <Th>City</Th>
                                <Th>Area</Th>
                                <Th>Lead Received On</Th>
                                <Th>Campaign</Th>
                                <Th>Campaign Details</Th>
                                <Th>Reference</Th>
                                <Th>Remark</Th> */}
                                {/* <Th>Next Followup Date</Th> */}
                                {/* <Th>From</Th>
                                <Th>To</Th>
                                <Th>Nationality</Th>
                                <Th>Doctor Name</Th>
                                <Th>Counselor Assign</Th>
                                <Th>Occupation</Th>
                                <Th>Email</Th>
                                <Th>Address</Th>
                                <Th>Blood Group</Th>
                                <Th>Pincode</Th>
                                <Th>Lead FollowUp Remark</Th>
                                <Th>Photo</Th>
                                <Th style={{ position: 'sticky', right: 60, background: '#fff', zIndex: 2, minWidth: '50px' }}>WhatsApp</Th>
                                <Th style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 2, minWidth: '50px' }}>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                getFollowups?.getFollowup?.data?.data?.length > 0 ? (
                                    getFollowups?.getFollowup?.data?.data?.map((res) => {
                                        return (
                                            <Tr key={res._id}>
                                                <Td>{res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.branch}</Td>
                                                <Td>{res.phoneNumber}</Td>
                                                <Td className='capitalize'>{res.firstName}</Td> */}
                                                {/* <Td>{res.middleName ? `${res.middleName.charAt(0).toUpperCase()}.` : ''}</Td> */}
                                                {/* <Td className='capitalize'>{res.lastName}</Td>
                                                <Td className="capitalize">
                                                    <span onClick={() => { updateToggle(res) }} className={`cursor-pointer ${res.leadStatus === "new" || res.leadStatus === "New"
                                                        ? "bg-[#198754] text-white px-3 py-1 rounded inline-block text-sm"
                                                        : res.leadStatus === "close"
                                                            ? "bg-[#0d6efd] text-white px-3 py-1 rounded inline-block text-sm"
                                                            : res.leadStatus === "exit"
                                                                ? "bg-[#dc3545] text-white px-3 py-1 rounded inline-block text-sm"
                                                                : res.leadStatus === "pending"
                                                                    ? "bg-[#ffc107] text-black px-3 py-1 rounded inline-block text-sm"
                                                                    : res.leadStatus === "pipeline"
                                                                        ? "bg-[#0dcaf0] text-white px-3 py-1 rounded inline-block text-sm"
                                                                        : res.leadStatus === "inProcess"
                                                                            ? "bg-[#fd7e14] text-white px-3 py-1 rounded inline-block text-sm"
                                                                            : res.leadStatus === "counsultation done"
                                                                                ? "bg-[#6c757d] text-white px-3 py-1 rounded inline-block text-sm"
                                                                                : "bg-transparent text-black"}`}>{res.leadStatus}</span>
                                                </Td>
                                                <Td>{res.leadFrom}</Td>
                                                <Td>{res.problem}</Td>
                                                <Td>{res.gender}</Td>
                                                <Td>{res.dateOfBirth ? moment(res.dateOfBirth).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.country}</Td>
                                                <Td>{res.state}</Td>
                                                <Td>{res.city}</Td>
                                                <Td>{res.area}</Td>
                                                <Td>{res.leadReceived}</Td>
                                                <Td>{res?.campaign[0]?.cname}</Td>
                                                <Td>{res?.campaign[0]?.description}</Td>
                                                <Td>{res?.reference[0]?.doctorDetail || res?.reference[0]?.personDetail}</Td>
                                                <Td>{res.remark}</Td>
                                                <Td>{res.from ? new Date(res.from).toLocaleTimeString() : ''}</Td>
                                                <Td>{res.to ? new Date(res.to).toLocaleTimeString() : ''}</Td>
                                                <Td>{res.nationality}</Td>
                                                <Td>{res.doctorName}</Td>
                                                <Td>{res.counselorAssign}</Td>
                                                <Td>{res.occupation}</Td>
                                                <Td>{res.email}</Td>
                                                <Td>{res.address}</Td>
                                                <Td>{res.bloodGroup}</Td>
                                                <Td>{res.pincode}</Td>
                                                <Td>{res.leadFollowUpRemark}</Td>
                                                <Td><img src={res.photo || userPhoto} alt='user photo' className='w-[60px]' /></Td>
                                                <Td style={{
                                                    position: 'sticky',
                                                    right: 60,
                                                    background: '#fff',
                                                    zIndex: 9,
                                                    textAlign: 'center',
                                                }}>
                                                    <div className="d-flex gap-2 fs-6 fw-bold" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}>
                                                        <MdWhatsapp className="text-success" size={30} />
                                                    </div>
                                                </Td>
                                                <Td style={{
                                                    position: 'sticky',
                                                    right: 0,
                                                    background: '#fff',
                                                    zIndex: 9,
                                                }}>
                                                    <div onClick={() => { updateToggle(res) }} className='d-flex gap-2 fs-6 fw-bold'>
                                                        <FaEdit className='text-success' />Edit
                                                    </div>
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan="33">No any followup</Td>
                                    </Tr>
                                )
                            }

                        </Tbody> */}
                            {getFollowups?.getFollowup?.data?.data?.length > 0 ? (getFollowups?.getFollowup?.data?.data?.map((res) => (
              <div key={res._id} className="lead-card mb-4 bg-white rounded-lg shadow p-4">
                <h3 className="text-xl font-medium mb-3 text-blue-900">
                  <FaUser className="inline-block mr-2 text-blue-900" size="18px" />
                  {res.firstName} {res.lastName}
                </h3>

                <TableContainer>
                  <Table variant="simple">
                    <Tbody>
                      <Tr>
                        <Td fontWeight="bold" py="1" lineHeight="short">
                          {/* <FaWpforms className="inline-block mr-2 text-blue-500" />
                          Lead Status:&nbsp;&nbsp; */}
                          {/* <button
                            disabled={localStorage.getItem('type')?.toLowerCase().trim() === 'lead'}
                            onClick={() => updateToggle(res)}
                            style={{
                              background: res.leadStatus
                                ? getBackgroundColor(res.leadStatus.trim().toLowerCase())
                                : 'transparent',
                              color: res.leadStatus ? 'white' : 'black',
                            }}
                            className="cursor-pointer px-2 py-0.5 rounded"
                          >
                            {res.leadStatus}
                          </button> */}
                          <FaWpforms className="inline-block mr-2 text-blue-500" />
                          Lead Status:&nbsp;&nbsp;
                          <span
                            onClick={() => {
                              updateToggle(res);
                            }}
                            className={`cursor-pointer ${res.leadStatus === 'new' || res.leadStatus === 'New'
                              ? 'bg-[#198754] text-white px-3 py-1 rounded inline-block text-sm'
                              : res.leadStatus === 'close'
                                ? 'bg-[#03367f] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'exit'
                                  ? 'bg-[#dc3545] text-white px-3 py-1 rounded inline-block text-sm'
                                  : res.leadStatus === 'pending'
                                    ? 'bg-[#ffc107] text-black px-3 py-1 rounded inline-block text-sm'
                                    : res.leadStatus === 'pipeline'
                                      ? 'bg-[#0dcaf0] text-white px-3 py-1 rounded inline-block text-sm'
                                      : res.leadStatus === 'inProcess'
                                        ? 'bg-[#fd7e14] text-white px-3 py-1 rounded inline-block text-sm'
                                        : res.leadStatus === 'counsultation done'
                                          ? 'bg-[#6c757d] text-white px-3 py-1 rounded inline-block text-sm'
                                          : 'bg-transparent text-black'
                              }`}
                          >
                            {res.leadStatus}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1" lineHeight="short">
                          <MdDateRange className="inline-block mr-2 text-green-500" />
                          nextFollowUpDate:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                          {res.nextFollowUpDate
                            ? moment(res.nextFollowUpDate).format('DD/MM/YYYY')
                            : ''}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1" lineHeight="short">
                          <FaRegClock className="inline-block  mr-2  text-orange-500" />
                          Time:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                          {res.createdAt ? formatTime(res.createdAt) : ''}
                          </span>
                        </Td>
                        <Td w="50px" py="1">
                          <div className="d-flex gap-3">
                            {/* <button
                                className="text-primary"
                                onClick={() => handlePhoneClick(res.phoneNumber)}
                                title="Call"
                              >
                                <FaPhone size={18} />
                              </button> */}
                            <button className="text-green-500 hover:text-green-700" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)} title="WhatsApp">
                              <MdWhatsapp size={28} />
                            </button>
                            {/* <button className="text-blue-500" onClick={() => handleView(res._id)} title="View">
                              <FiTarget size={28} />
                            </button> */}
                            <button className="text-success" onClick={() => updateToggle(res)} title="Edit">
                              <FaEdit size={28} />
                            </button>
                            {/* <button className="text-red-500" onClick={() => deleteData(res._id)} title="Delete">
                              <MdDelete size={28} />
                            </button> */}
                          </div>
                        </Td>
                      </Tr>

                      <Tr sx={{ borderBottom: "none" }}>
                        <Td fontWeight="bold" py="1">
                          <FiTarget className="inline-block  mr-2  text-purple-500" />
                          Lead From:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                              {res.leadFrom}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1">
                          <FaPhone className="inline-block  mr-2  text-blue-500" />
                          Phone:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                              {res.phoneNumber}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1">
                          <MdLocationOn className="inline-block  mr-2  text-red-500" />
                          Location:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                              {res.city ? `${res.city}, ${res.country || ''}` : 'N/A'}
                          </span>
                        </Td>

                        <Td colSpan={2}></Td>
                      </Tr>

                      <Tr sx={{ borderBottom: "none" }}>
                      <Td fontWeight="bold" py="1">
                            <MdComment className="inline-block  mr-2  text-gray-500" />
                            Remark:&nbsp;&nbsp;
                            <span style={{
                              fontWeight: "normal", display: "contents",
                              maxWidth: "300px",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word"
                            }}>
                              {res.remark}
                            </span>
                          </Td>
                        <Td fontWeight="bold" py="1">
                          <MdLocationOn className="inline-block mr-2 text-blue-500" />
                          Branch:&nbsp;&nbsp; 
                          <span style={{fontWeight:"normal"}}>
                              {res.branch}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1">
                          <FaCalendarPlus className="inline-block mr-2 text-purple-500" />
                          Lead Received:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                              {res.leadReceived}
                          </span>
                        </Td>
                      </Tr>
                      <Tr>
                        <Td fontWeight="bold" py="1">
                          <MdCampaign className="inline-block mr-2 text-blue-500" />
                          Campaign:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                          {res?.campaign[0]?.cname}
                          </span>
                        </Td>
                        <Td fontWeight="bold" py="1">
                          <MdDescription className="inline-block mr-2 text-gray-500" />
                          Campaign Details:&nbsp;&nbsp;
                          <span style={{fontWeight:"normal"}}>
                          {res?.campaign[0]?.description}
                          </span>
                        </Td>
                        {/* <Td fontWeight="bold" py="1">
                              <FaUser className="inline-block mr-2 text-green-500" />
                              Lead Assign:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.counselorAssignName}
                              </span>
                            </Td> */}
                      </Tr>
                      <Tr>
                        <button
                          className="mobile-only-button py-[8px] px-[20px] rounded-full !bg-theme-dark fw-bold d-flex align-item-center border-0 text-white mt-2 ml-5"
                          onClick={() => handlePhoneClick(res.phoneNumber)}
                          title="Call"
                        >
                          <FaPhone size={18} className='mr-5 mt-1' /> Call
                        </button>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </div>
            ))
          ): (
              <div className="text-center py-4 w-full">
                <p className="text-gray-500 font-medium">No any followup</p>
                </div>
                )}
          
                    </Table>
                </TableContainer >
            </div >

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />
            <FileUpdate
                updateModal={updateModal}
                updateToggle={updateToggle}
                updateId={updateId}
                searchDefault1={searchDefault}
            />

            {/* WhatsApp Modal */}
            <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Send WhatsApp Message</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <div className="mb-4">
                            <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                disabled
                                value={selectedLeadName}
                                className="bg-light border-0 fw-bold text-dark"
                                style={{ fontSize: '1.1rem' }}
                            />
                        </div>

                        <div className="mb-4">
                            <Form.Label className="fw-bold text-dark">Mobile Number</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                disabled
                                value={selectedMobileNumber}
                                className="bg-light border-0 fw-bold text-dark"
                                style={{ fontSize: '1.1rem' }}
                            />
                        </div>

                        <div className="mb-4">
                            <Form.Label className="fw-bold text-dark">Select Message</Form.Label>
                            <Form.Select
                                className="border-2"
                                value={whatsappDropdownSelection}
                                onChange={(e) => {
                                    setWhatsappDropdownSelection(e.target.value);
                                    setErrors((prev) => ({ ...prev, dropdown: '' }));
                                }}
                            >
                                <option value="">Select Option</option>
                                {whatsAppMessage.map((msg) => (
                                    <option key={msg._id} value={msg._id}>
                                        {msg.title}
                                    </option>
                                ))}
                                <option value="other">Other</option>
                            </Form.Select>
                            {errors.dropdown && (
                                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.dropdown}</div>
                            )}
                        </div>

                        {whatsappDropdownSelection === 'other' && (
                            <div className="mb-4">
                                <Form.Control
                                    type="text"
                                    placeholder="Please specify"
                                    className="border-2"
                                    value={otherMessage}
                                    onChange={(e) => {
                                        setOtherMessage(e.target.value);
                                        setErrors((prev) => ({ ...prev, other: '' }));
                                    }}
                                />
                                {errors.other && (
                                    <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.other}</div>
                                )}
                            </div>
                        )}
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={closeWhatsappModal}>
                        Cancel
                    </Button>
                    <Button
                        className="!bg-theme-dark border-0 px-4"
                        onClick={handleSend}
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
